// Module
var code = `<div class="panel bookmark_item"> <span class="bookmark_title">#TITLE</span> <p class="bookmark_content">#CONTENT</p> <button class="panel_button view_button">View</button> </div>`;
// Exports
export default code;